const CLEAR_DRAFT = state => {
  state.draft = {
    name: null,
    unitId: null,
    type: 'ingredient',
    quantity: 0,
    salesPrice: null,
    image: null,
    items: [],
  };
};

const UPDATE_DRAFT_RECIPE = (state, payload) => {
  state.draft = {
    ...state.draft,
    ...payload,
  };
};

export default {
  CLEAR_DRAFT,
  UPDATE_DRAFT_RECIPE,
};
